import { render, staticRenderFns } from "./PayrollEditHistory.vue?vue&type=template&id=0cf45378&scoped=true&"
import script from "./PayrollEditHistory.vue?vue&type=script&lang=js&"
export * from "./PayrollEditHistory.vue?vue&type=script&lang=js&"
import style0 from "./PayrollEditHistory.vue?vue&type=style&index=0&id=0cf45378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf45378",
  null
  
)

export default component.exports